function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
import React, { useState, useEffect } from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, LineElement, CategoryScale, LinearScale, PointElement, Tooltip, Legend } from 'chart.js';
import { Button, Table } from 'antd';
import { formatCountNumber, formatCurrency } from '../../utils/format-data';
import dayjs from 'dayjs';
ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Tooltip, Legend);
const normalizeChartData = (items, periodMode) => {
    if (periodMode === 'year') {
        const filled = Array.from({
            length: 12
        }, (_, i) => {
            const month = i + 1;
            const found = items.find(x => x.month === month);
            return _objectSpread({
                month
            }, found);
        });
        return {
            data: filled,
            labels: filled.map(i => `${i.month}月`)
        };
    }
    return {
        data: items,
        labels: items.map(i => {
            const d = new Date(i.day);
            return `${d.getDate()}`;
        })
    };
};
export function LineChart({ items, gender, params, onChange }) {
    const _useState = useState('chart'), _useState2 = _slicedToArray(_useState, 2), viewMode = _useState2[0], setViewMode = _useState2[1];
    const _useState3 = useState([]), _useState4 = _slicedToArray(_useState3, 2), data = _useState4[0], setData = _useState4[1];
    const _useState5 = useState([]), _useState6 = _slicedToArray(_useState5, 2), labels = _useState6[0], setLabels = _useState6[1];
    const _useState7 = useState([]), _useState8 = _slicedToArray(_useState7, 2), values = _useState8[0], setValues = _useState8[1];
    const getValueByGender = item => {
        var _a, _b, _c, _d;
        if (gender === 'male')
            return (_a = item.male_users) !== null && _a !== void 0 ? _a : 0;
        if (gender === 'female')
            return (_b = item.female_users) !== null && _b !== void 0 ? _b : 0;
        return ((_c = item.male_users) !== null && _c !== void 0 ? _c : 0) + ((_d = item.female_users) !== null && _d !== void 0 ? _d : 0);
    };
    const chartData = {
        labels,
        datasets: [{
                data: values,
                borderColor: '#1F7A4D',
                borderWidth: 2.5,
                tension: 0,
                pointRadius: 0,
                pointHoverRadius: 5,
                hitRadius: 14,
                hoverRadius: 6
            }]
    };
    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
            mode: 'nearest',
            intersect: false,
            axis: 'x'
        },
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                displayColors: false,
                backgroundColor: '#2A2A2A',
                padding: 10,
                cornerRadius: 4,
                callbacks: {
                    title: items => {
                        const item = data[items[0].dataIndex];
                        if (!item)
                            return '';
                        if (params.mode === 'year') {
                            return `${item.month}月`;
                        }
                        if (params.mode === 'month' && 'day' in item && item.day) {
                            const d = new Date(item.day);
                            return `${d.getMonth() + 1}月${d.getDate()}日`;
                        }
                        return '';
                    },
                    label: ctx => {
                        const label = gender === 'male' ? '男性ユーザー' : gender === 'female' ? '女性ユーザー' : '合計ユーザー';
                        return formatCountNumber(Number(ctx.raw)) + ' ユーザー';
                    }
                }
            }
        },
        scales: {
            x: {
                grid: {
                    display: false
                },
                ticks: {
                    color: '#666',
                    font: {
                        size: 11
                    },
                    autoSkip: true
                }
            },
            y: {
                min: 0,
                beginAtZero: true,
                grid: {
                    color: '#EEEEEE'
                },
                ticks: {
                    callback: v => Number(v).toLocaleString('ja-JP')
                }
            }
        }
    };
    useEffect(() => {
        if (!(items === null || items === void 0 ? void 0 : items.length))
            return;
        if (!params.mode)
            return;
        const normalized = normalizeChartData(items, params.mode);
        setData(normalized.data);
        setLabels(normalized.labels);
        setValues(normalized.data.map(getValueByGender));
    }, [items, params.mode, gender]);
    const columns = React.useMemo(() => {
        if (params.mode === 'year') {
            if (gender === 'male') {
                return [{
                        title: '月',
                        dataIndex: 'month',
                        render: v => `${v}月`,
                        width: 70
                    }, {
                        title: '購入ユーザー',
                        dataIndex: 'purchased_users',
                        render: v => formatCountNumber(v),
                        width: 110
                    }, {
                        title: 'いいねユーザー',
                        dataIndex: 'like_users',
                        render: v => formatCountNumber(v)
                    }, {
                        title: '男性ユーザー',
                        dataIndex: 'male_users',
                        render: v => formatCountNumber(v)
                    }, {
                        title: '男性ユーザー売上',
                        dataIndex: 'male_sales',
                        render: v => formatCurrency({
                            value: v
                        }),
                        width: 240
                    }];
            }
            if (gender === 'female') {
                return [{
                        title: '月',
                        dataIndex: 'month',
                        render: v => `${v}月`,
                        width: 70
                    }, {
                        title: '購入ユーザー',
                        dataIndex: 'purchased_users',
                        render: v => formatCountNumber(v),
                        width: 110
                    }, {
                        title: 'いいねユーザー',
                        dataIndex: 'like_users',
                        render: v => formatCountNumber(v)
                    }, {
                        title: '女性ユーザー',
                        dataIndex: 'female_users',
                        render: v => formatCountNumber(v)
                    }, {
                        title: '女性ユーザー売上',
                        dataIndex: 'female_sales',
                        render: v => formatCurrency({
                            value: v
                        }),
                        width: 240
                    }];
            }
            return [{
                    title: '月',
                    dataIndex: 'month',
                    render: v => `${v}月`,
                    width: 70
                }, {
                    title: '購入ユーザー',
                    dataIndex: 'purchased_users',
                    render: v => formatCountNumber(v),
                    width: 110
                }, {
                    title: 'いいねユーザー',
                    dataIndex: 'like_users',
                    render: v => formatCountNumber(v)
                }, {
                    title: '男性ユーザー',
                    dataIndex: 'male_users',
                    render: v => formatCountNumber(v)
                }, {
                    title: '女性ユーザー',
                    dataIndex: 'female_users',
                    render: v => formatCountNumber(v)
                }, {
                    title: 'ユーザー合計',
                    dataIndex: 'total_users',
                    render: v => formatCountNumber(v)
                }, {
                    title: '男性ユーザー売上',
                    dataIndex: 'male_sales',
                    render: v => formatCurrency({
                        value: v
                    }),
                    width: 200
                }, {
                    title: '女性ユーザー売上',
                    dataIndex: 'female_sales',
                    render: v => formatCurrency({
                        value: v
                    }),
                    width: 200
                }, {
                    title: '合計',
                    dataIndex: 'total_sales',
                    render: v => formatCurrency({
                        value: v
                    })
                }];
        }
        // By month
        if (gender === 'male') {
            return [{
                    title: '日',
                    dataIndex: 'day',
                    render: v => dayjs(v).format('D日'),
                    width: 70
                }, {
                    title: '購入ユーザー',
                    dataIndex: 'purchased_users',
                    render: v => formatCountNumber(v),
                    width: 110
                }, {
                    title: 'いいねユーザー',
                    dataIndex: 'like_users',
                    render: v => formatCountNumber(v)
                }, {
                    title: '男性ユーザー',
                    dataIndex: 'male_users',
                    render: v => formatCountNumber(v)
                }, {
                    title: '男性ユーザー売上',
                    dataIndex: 'male_sales',
                    render: v => formatCurrency({
                        value: v
                    }),
                    width: 200
                }, {
                    title: '合計',
                    dataIndex: 'total_sales',
                    render: v => formatCurrency({
                        value: v
                    })
                }];
        }
        if (gender === 'female') {
            return [{
                    title: '日',
                    dataIndex: 'day',
                    render: v => dayjs(v).format('D日'),
                    width: 70
                }, {
                    title: '購入ユーザー',
                    dataIndex: 'purchased_users',
                    render: v => formatCountNumber(v),
                    width: 110
                }, {
                    title: 'いいねユーザー',
                    dataIndex: 'like_users',
                    render: v => formatCountNumber(v)
                }, {
                    title: '女性ユーザー',
                    dataIndex: 'female_users',
                    render: v => formatCountNumber(v)
                }, {
                    title: '女性ユーザー売上',
                    dataIndex: 'female_sales',
                    render: v => formatCurrency({
                        value: v
                    }),
                    width: 200
                }];
        }
        return [{
                title: '日',
                dataIndex: 'day',
                render: v => dayjs(v).format('D日'),
                width: 70
            }, {
                title: '購入ユーザー',
                dataIndex: 'purchased_users',
                render: v => formatCountNumber(v),
                width: 110
            }, {
                title: 'いいねユーザー',
                dataIndex: 'like_users',
                render: v => formatCountNumber(v),
                width: 100
            }, {
                title: '男性ユーザー',
                dataIndex: 'male_users',
                render: v => formatCountNumber(v)
            }, {
                title: '女性ユーザー',
                dataIndex: 'female_users',
                render: v => formatCountNumber(v)
            }, {
                title: 'ユーザー合計',
                dataIndex: 'total_users',
                render: v => formatCountNumber(v)
            }, {
                title: '男性ユーザー売上',
                dataIndex: 'male_sales',
                render: v => formatCurrency({
                    value: v
                }),
                width: 200
            }, {
                title: '女性ユーザー売上',
                dataIndex: 'female_sales',
                render: v => formatCurrency({
                    value: v
                }),
                width: 200
            }, {
                title: '合計',
                dataIndex: 'total_sales',
                render: v => formatCurrency({
                    value: v
                })
            }];
    }, [params.mode, gender]);
    const tableData = React.useMemo(() => {
        return data.map(item => {
            var _a, _b, _c, _d, _e, _f, _g;
            const maleUsers = (_a = item.male_users) !== null && _a !== void 0 ? _a : 0;
            const femaleUsers = (_b = item.female_users) !== null && _b !== void 0 ? _b : 0;
            const maleSales = (_c = item.male_sales) !== null && _c !== void 0 ? _c : 0;
            const femaleSales = (_d = item.female_sales) !== null && _d !== void 0 ? _d : 0;
            if (gender === 'male') {
                return _objectSpread(_objectSpread({}, item), {}, {
                    like_users: (_e = item.like_users) !== null && _e !== void 0 ? _e : 0,
                    female_users: 0,
                    female_sales: 0,
                    total_users: maleUsers,
                    total_sales: maleSales
                });
            }
            if (gender === 'female') {
                return _objectSpread(_objectSpread({}, item), {}, {
                    like_users: (_f = item.like_users) !== null && _f !== void 0 ? _f : 0,
                    male_users: 0,
                    male_sales: 0,
                    total_users: femaleUsers,
                    total_sales: femaleSales
                });
            }
            return _objectSpread(_objectSpread({}, item), {}, {
                like_users: (_g = item.like_users) !== null && _g !== void 0 ? _g : 0,
                total_users: maleUsers + femaleUsers,
                total_sales: maleSales + femaleSales
            });
        });
    }, [data, gender]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "grid gap-6"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex justify-end"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex gap-2"
    }, /*#__PURE__*/ React.createElement(Button, {
        onClick: () => setViewMode('chart'),
        className: viewMode === 'chart' ? '!bg-[#f0c52a36]' : ''
    }, "\u30B0\u30E9\u30D5"), /*#__PURE__*/ React.createElement(Button, {
        onClick: () => setViewMode('table'),
        className: viewMode === 'table' ? '!bg-[#f0c52a36]' : ''
    }, "\u8868"))), /*#__PURE__*/ React.createElement("div", {
        style: {
            height: 400
        },
        className: "max-w-content"
    }, viewMode === 'chart' ? /*#__PURE__*/ React.createElement(Line, {
        data: chartData,
        options: chartOptions
    }) : /*#__PURE__*/ React.createElement(Table, {
        key: params.mode,
        rowKey: (__, index) => `sale-by-user-${index}-${params.mode}`,
        dataSource: tableData,
        columns: columns,
        pagination: false,
        locale: {
            emptyText: 'データがありません'
        },
        scroll: {
            y: 380
        }
    })));
}
